import "./styles/_main.scss";
appHost.plugins.register({
    // #region Vars
    name: "288a.ecommerce.core",
    // #endregion
    // #region Register
    register() {
        appHost.components.registerAll(require.context('./views', true, /(?<!views)\.vue$/));
        appHost.actions.registerAll(require.context('./actions', true, /(?<!views)\.ts$/));
    },
    // #endregion
});
